import Container = Phaser.GameObjects.Container;
import { Scene } from 'phaser';
import { SpineAnim } from './spineAnim';
import Text = Phaser.GameObjects.Text;
import Sprite = Phaser.GameObjects.Sprite;
import TimerEvent = Phaser.Time.TimerEvent;

export class MonkeyView extends Container {
    private spine: SpineAnim;
    private hitHistory: {text: Text, op: {function: string, value: number}}[] = [];
    private historyContainer: Container;
    private balanceText: Text;
    private currentBalance: number = 1;
    // private isPlayingDazed: boolean;
    // private isPlayingHit: boolean;
    private animTimeEvent: TimerEvent;
    private animState: AnimationStates



    constructor(scene: Scene) {
        super(scene);

        // const graph = this.scene.add.graphics();
        // this.add(graph);
        // graph.fillStyle(0xff0000, 1);
        // graph.fillCircle(0, 0, 25);

        //
        this.spine = new SpineAnim(this.scene, 'Monkey');
        this.add(this.spine);
        this.spine.y += 110;

        const { spine } = this.spine;
        this.spine.loopAnimation('Falling');
        this.spine.setScale(0.65);
        this.scene.events.on('hitWithCoin', this.handleHitWithCoin, this);
        spine.timeScale = 1;

        this.historyContainer = this.scene.add.container();
        this.historyContainer.setPosition(-159, -210);
        this.add(this.historyContainer);
        this.initBalanceText();
    }

    public destroy(fromScene?: boolean) {
        this.scene.events.off('hitWithCoin', this.handleHitWithCoin, this);
        super.destroy(fromScene);
    }

    public playSwing() {
        this.startAnimationState(AnimationStates.Swing);
    }

    public reactToBite() {
        // const { spine } = this.spine;
        this.animateMonkeyHit()
        this.animateCoinsFlyingOut();
    }

    public playLanding() {
        const { spine } = this.spine;
        spine.timeScale = 1.21;
        spine.off('complete');
        spine.play('Landing');
        spine.once('complete', () => {
            spine.timeScale = 1;
            spine.play(Math.random() > .5 ? "Big win" : "Small win");
        })
    }

    public playDeath() {
        const { spine } = this.spine;
        spine.off('complete');
        spine.play('Death start');
        spine.timeScale = 1.38;
        spine.once('complete', () => {
            spine.play('Falling for death');
            spine.timeScale = 1.64;
            spine.once('complete', () => {
                spine.play('Spike death');
            });
        });
    }

    private handleHitWithCoin(op: { function: string; value: number }) {
        let sign = '';
        switch (op.function) {
            case 'divide':
                sign = '/';
                break;
            case 'add':
                sign = '+';
                break;
            case 'multiply':
                sign = 'x';
                break;
        }
        const color = op.function === 'divide' ? `#ff0000` : `#00ff00`;
        const text = this.scene.add.text(0, 0, `${sign}${op.value}`, {
            fontFamily: 'Rubik',
            color,
            fontSize: '42px',
            align: "center"
        });
        text.setStroke('#000000', 6);
        text.setShadow(2, 2, '#000000', 4, true, true);
        text.setAlpha(0);
        text.setOrigin(.5);
        this.historyContainer.add(text);
        const item = { text, op}
        if (!this.hitHistory.length) {
            this.animateHistoryText(item);
            this.hitHistory.push(item);
        } else {
            this.hitHistory.push(item);
        }
    }

    private animateHistoryText(historyItem: {text: Text, op: {function: string, value: number}}) {
        let isRemoved = false;
        const {text} = historyItem;
        const doNextOne = () => {
            const i = this.hitHistory.indexOf(historyItem)
            this.hitHistory.splice(i, 1)
            if (this.hitHistory.length) {
                this.animateHistoryText(this.hitHistory[0]);
            }
        };
        this.scene.tweens.add({
            targets: text,
            duration: 800,
            alpha: 0,
            y: '-=100',
            onStart: () => {
                text.setAlpha(1);
            },
            onUpdate: (p) => {
                if (p.progress >= 0.41) {
                    if (!isRemoved) {
                        isRemoved = true;
                        doNextOne();
                    }
                }
            },
            onComplete: () => {
                text.destroy();
            },
        });
        const {value} = historyItem.op;
        switch (historyItem.op.function) {
            case "divide":
                this.currentBalance /= historyItem.op.value;
                break;
            case "add":
                this.currentBalance += historyItem.op.value;
                break;
            case "multiply":
                this.currentBalance *= historyItem.op.value;
                break;
        }
        this.balanceText.setText(this.currentBalance.toFixed(2))
    }

    private initBalanceText() {
        const {x, y} = this.historyContainer
        this.balanceText = this.scene.add.text(0, 0, "1.00", {
            fontFamily: 'Rubik',
            color: `#ffffff`,
            fontSize: '42px',
            align: "center"
        });
        this.balanceText.setStroke('#000000', 6);
        this.balanceText.setShadow(2, 2, '#000000', 4, true, true);
        this.balanceText.setPosition(
            x, y+ 45
        );
        this.balanceText.setOrigin(0.5)
        this.add(this.balanceText);
    }

    private checkHistoryQueue() {}

    private animateMonkeyHit() {
        this.startAnimationState(AnimationStates.Dazed)


        this.scene.tweens.killTweensOf(this.spine);
        this.spine.setAlpha(1)
        this.scene.tweens.add({
            targets: this.spine,
            alpha: 0.35,
            duration: 55,
            yoyo: true,
            repeat: 2,
            delay: 195
        })
    }

    private animateCoinsFlyingOut() {
        let sprite: Sprite;
        const coinSprites: Sprite[] = [];
        const x = -57;
        const y = -103;
        for (let i = 0; i < 16; i++) {
            sprite = this.scene.add.sprite(x, y, "game", `coins/${i}.png`);
            this.add(sprite);
            sprite.setAlpha(0);
            coinSprites.push(sprite)
        }
        this.bringToTop(this.spine);

        coinSprites.forEach((coin) => {
            // spawn at the origin each time you fire the burst
            // Direction: centered upward with some left/right spread.
            // If you want full 360°, set spread = Math.PI * 2 and center = 0.
            const center = -Math.PI / 2;               // straight up
            const spread = Math.PI * 0.9;              // ~162° cone
            const theta = center + Phaser.Math.FloatBetween(-spread / 2, spread / 2);
            // How far and how fast each coin travels
            const dist = Phaser.Math.Between(180, 240);
            const tx = x + Math.cos(theta) * dist;
            const ty = y + Math.sin(theta) * dist;
            const spin = Phaser.Math.Between(-540, 540);
            const delay = Phaser.Math.Between(110, 160);
            const duration  = Phaser.Math.Between(810, 990);
            this.scene.tweens.add({
                targets: coin,
                x: tx - 160,
                y: ty,
                angle: spin,
                onStart: () => coin.setAlpha(1),
                // fades near the end of flight
                // slight size variance sells depth without looking weird
                scale: { from: 1, to: Phaser.Math.FloatBetween(0.85, 1.1) },
                ease: 'Expo.easeOut',                     // fast launch, easing off naturally
                duration,  // travel time
                delay,       // stagger

            });
            this.scene.tweens.add({
                targets: coin, delay: delay + (duration * 0.3),
                duration: 185,
                alpha: 0,
                onComplete: () => coin.destroy()
            })
        });
    }

    private startAnimationState(state: AnimationStates) {
        const { spine } = this.spine;
        this.scene.time.removeEvent(this.animTimeEvent);
        spine.off('complete');
        const continueFalling = () => {
            spine.once('complete', () => {
                spine.timeScale  = 1;
                this.animState = AnimationStates.Fall;
                this.spine.loopAnimation('Falling');
            });
        }
        switch (state) {
            case AnimationStates.Dazed:
                if (this.animState === AnimationStates.Swing) return;
                if (this.animState === AnimationStates.Dazed) return;
                this.animState = state;
                this.animTimeEvent = this.scene.time.delayedCall(1, () => {
                    const { spine } = this.spine;
                    spine.off('complete');
                    spine.play('Damage');
                    spine.timeScale = 1.27
                    spine.once('complete', () => {
                        this.spine.loopAnimation('Falling');
                    });
                })
                break;
            case AnimationStates.Swing:
                this.animState = state;
                spine.timeScale = 1.37
                spine.play('Swing');
                continueFalling();
                break;
            case AnimationStates.Fall:
                this.animState = state;
        }

    }
}
enum AnimationStates {
    Fall, Swing, Dazed
}
